import React from 'react';

import { COLOR } from 'component/comm'

// ----------------------------------------------------------------------------------
const TouchSvg = (fillColor) => {
    let tmpColor = COLOR.GRAY_1
    if (fillColor) {
        tmpColor = fillColor
    }

    return (
        <svg t="1713945721578" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8859" width="1em" height="1em">
            <path d="M841.7536 396.741973l-2.577067 0c-18.950827 0-34.49856 5.43744-49.460907 14.71488-13.120853-38.23104-46.460587-65.774933-89.402027-65.774933-18.950827 0-37.072213 5.435733-52.03968 14.71488-13.115733-38.23104-46.45888-65.774933-89.434453-65.774933-16.744107 0-32.325973 4.205227-46.09536 11.56096l0-98.387627c0-53.599573-40.553813-97.012053-94.511787-97.012053s-97.73568 43.451733-97.73568 97.012053l0 376.66304-59.32032-59.10528c-38.15936-37.906773-105.709227-32.503467-138.217813 0C90.453333 557.86496 69.142187 623.235413 115.674453 669.805227l272.95232 271.138133c5.613227 5.579093 11.81184 10.251947 18.336427 14.204587 49.754453 40.58624 106.79296 64.612693 227.360427 64.612693 275.449173 0 300.96384-148.61312 300.96384-331.912533L935.287467 493.79328C935.248213 440.195413 895.750827 396.741973 841.7536 396.741973L841.7536 396.741973 841.7536 396.741973zM883.790507 687.81568c0 155.10016-0.725333 280.84736-249.506133 280.84736-105.376427 0-168.6528-23.478613-216.594773-71.098027L159.30368 640.88576c-22.86592-22.864213-17.102507-52.077227 1.599147-70.811307 18.696533-18.694827 53.050027-19.34848 71.133867-1.409707 0 0 45.335893 45.04576 84.4032 83.889493 29.53216 29.390507 55.514453 55.190187 55.514453 55.190187l0-489.728c0-25.362773 20.73088-45.948587 46.312107-45.948587 25.58464 0 43.052373 20.585813 43.052373 45.948587l0 311.509333 0.510293 0c-0.32768 1.631573-0.510293 3.36896-0.510293 5.10976 0 14.09536 11.523413 25.547093 25.729707 25.547093 14.206293 0 25.729707-11.414187 25.729707-25.547093 0-1.742507-0.180907-3.44576-0.508587-5.10976l0.508587 0 0-127.67232c0-25.36448 18.484907-45.950293 44.064427-45.950293 0 0 45.298347-0.6144 45.298347 45.950293l0 168.512853 0.510293 0c-0.325973 1.631573-0.510293 3.36896-0.510293 5.10976 0 14.09536 11.523413 25.547093 25.729707 25.547093 14.204587 0 25.728-11.414187 25.728-25.547093 0-1.742507-0.177493-3.44576-0.503467-5.10976l0.503467 0 0-117.4528c0-25.36448 18.193067-45.952 43.777707-45.952 0 0 46.24384 2.90304 46.24384 45.952l0 148.109653 0.503467 0c-0.325973 1.629867-0.503467 3.372373-0.503467 5.108053 0 14.09536 11.523413 25.547093 25.729707 25.547093 14.204587 0 25.076053-11.414187 25.076053-25.547093 0-1.737387-0.182613-3.44576-0.469333-5.108053l0.469333 0 0-101.10976c0-25.36448 19.060053-45.945173 44.644693-45.945173 0 0 44.829013-1.814187 44.829013 45.945173l0 187.900587L883.790507 687.813973 883.790507 687.81568zM282.33728 352.462507l0-85.77536c-8.15616-18.300587-12.796587-38.562133-12.796587-59.86816 0-81.317547 65.918293-147.23584 147.24096-147.23584 81.319253 0 147.237547 65.918293 147.237547 147.23584 0 11.086507-1.3056 21.886293-3.662507 32.28672 18.51904 0.725333 35.223893 8.410453 47.399253 20.765013 4.712107-16.889173 7.502507-34.602667 7.502507-53.01248 0-109.590187-88.859307-198.44608-198.44608-198.44608-109.585067 0-198.439253 88.855893-198.439253 198.44608C218.33728 264.475307 243.054933 316.22144 282.33728 352.462507L282.33728 352.462507 282.33728 352.462507zM282.33728 352.462507" fill={tmpColor} p-id="14736"></path>
        </svg>
    )
}

const DountSvg = (fillColor) => {
    let tmpColor = COLOR.GRAY_1
    if (fillColor) {
        tmpColor = fillColor
    }

    return (
        <svg t="1713945970809" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8866" width="1em" height="1em">
            <path d="M512 960C264.96 960 64 759.04 64 512S264.96 64 512 64s448 200.96 448 448-200.96 448-448 448z m0-832c-211.743 0-384 172.257-384 384s172.257 384 384 384 384-172.257 384-384-172.257-384-384-384z" fill={tmpColor} p-id="38737"></path>
            <path d="M514.56 829.44c-175.043 0-317.44-142.397-317.44-317.44s142.397-317.44 317.44-317.44S832 336.957 832 512 689.603 829.44 514.56 829.44z m0-589.532c-150.036 0-272.092 122.056-272.092 272.092S364.524 784.092 514.56 784.092c150.042 0 272.092-122.056 272.092-272.092S664.602 239.908 514.56 239.908z" fill={tmpColor} p-id="38738"></path>
        </svg>
    )
}


const SwitchCameraSvg = (fillColor) => {
    let tmpColor = COLOR.GRAY_1
    if (fillColor) {
        tmpColor = fillColor
    }

    return (
        <svg t="1713945611081" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8868" width="1em" height="1em">
            <path d="M138.666667 455.424v71.936C91.434667 554.666667 64 586.453333 64 618.666667c0 64.768 115.712 132.138667 288 158.762666v-35.157333a21.333333 21.333333 0 0 1 32.554667-18.176L503.893333 797.866667a21.333333 21.333333 0 0 1 0 36.266666L384.554667 907.946667a21.333333 21.333333 0 0 1-32.554667-18.176v-47.573334C145.92 812.501333 0 728.064 0 618.666667c0-65.578667 52.821333-122.112 138.666667-163.242667z m746.709333 0C971.221333 496.64 1024 553.173333 1024 618.666667c0 114.346667-159.317333 201.386667-380.288 227.157333a32 32 0 1 1-7.424-63.573333l11.434667-1.408c185.6-23.808 312.277333-94.421333 312.277333-162.176 0-32.213333-27.392-64-74.624-91.306667v-71.893333zM601.6 85.333333a64 64 0 0 1 56.490667 33.877334l21.76 40.789333h56.149333a106.666667 106.666667 0 0 1 106.666667 106.666667v256a106.666667 106.666667 0 0 1-106.666667 106.666666H288a106.666667 106.666667 0 0 1-106.666667-106.666666v-256a106.666667 106.666667 0 0 1 106.666667-106.666667h56.149333l21.76-40.789333A64 64 0 0 1 422.4 85.333333h179.2z m0 64H422.4l-39.850667 74.666667H288a42.666667 42.666667 0 0 0-42.624 40.533333l-0.042667 2.133334v256a42.666667 42.666667 0 0 0 40.533334 42.624l2.133333 0.042666h448a42.666667 42.666667 0 0 0 42.624-40.533333l0.042667-2.133333v-256a42.666667 42.666667 0 0 0-40.533334-42.624l-2.133333-0.042667h-94.592L601.6 149.333333zM512 256a128 128 0 1 1 0 256 128 128 0 0 1 0-256z m0 53.333333a74.666667 74.666667 0 1 0 0 149.333334 74.666667 74.666667 0 0 0 0-149.333334z" fill={tmpColor} p-id="6837"></path>
        </svg>
    )
}

const BackSvg = (fillColor) => {
    let tmpColor = COLOR.PRIMARY
    if (fillColor) {
        tmpColor = fillColor
    }

    return (
        <svg t="1713945611082" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8869" width="1em" height="1em">
            <path d="M395.21518 513.604544l323.135538-312.373427c19.052938-18.416442 19.052938-48.273447 0-66.660212-19.053961-18.416442-49.910737-18.416442-68.964698 0L291.75176 480.290811c-19.052938 18.416442-19.052938 48.273447 0 66.660212l357.633237 345.688183c9.525957 9.207709 22.01234 13.796214 34.497699 13.796214 12.485359 0 24.971741-4.588505 34.466999-13.82896 19.052938-18.416442 19.052938-48.242747 0-66.660212L395.21518 513.604544z" fill={tmpColor} p-id="2369"></path>
        </svg>
    )
}

const ShareSvg = (fillColor) => {
    let tmpColor = COLOR.GRAY_8
    if (fillColor) {
        tmpColor = fillColor
    }

    return (
        <svg t="1713945611089" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8869" width="1.5em" height="1em">
            <path fill={tmpColor} d="M662.196495 1023.233272a153.345586 153.345586 0 0 1-151.324212-148.2573c-1.324348-26.556667-1.254646-53.183037 0-79.670002 0.975836-23.280648-8.78252-31.29644-31.226738-27.881016-98.629093 14.428426-191.054659 42.727656-267.100129 112.01198a318.680008 318.680008 0 0 0-54.925601 70.608672c-28.438636 46.003676-58.131918 61.686747-98.55939 51.370771C21.839269 991.727724-0.814056 961.895038 0.022375 910.175754c2.439589-143.726635 36.593833-278.810156 121.003607-397.79239 86.082636-121.630931 204.367844-194.818596 347.885372-228.275815 31.157035-6.970254 45.794568-19.098496 42.448846-53.043632-3.066912-30.878225-0.487918-62.31407-0.627322-93.471105 0-56.598462 25.580832-98.28058 75.696957-122.188551s102.880948-20.144034 147.14206 14.776938q239.288816 188.824178 476.068341 381.063781c69.702539 56.459057 67.82057 153.345586-2.300184 209.73494q-226.602954 182.411544-453.624124 364.335171c-28.299231 22.444218-57.853107 42.936764-91.519433 37.918181z m-556.783882-174.256347c120.306582-132.434824 270.376149-178.15969 436.407597-183.457083 49.97672-1.603158 62.732285 12.964672 63.289905 63.986931 0 45.097543-0.906133 90.195085 1.045538 135.222925a62.732285 62.732285 0 0 0 37.709074 57.713703c24.047376 11.431216 37.151453-5.645906 51.649581-17.216527q219.423593-175.092778 438.080458-351.231094c38.754612-31.29644 39.033422-46.561296-0.487918-78.415357C984.91925 355.482949 835.895222 236.988632 687.289409 117.657886c-17.28623-13.940508-35.896808-23.768566-57.156082-14.428426s-24.674699 31.57525-24.674699 53.113335v155.994282c0 29.762984-13.940508 47.049214-44.052005 52.276904a954.924784 954.924784 0 0 0-94.656048 20.910762C245.793527 447.002382 118.516691 635.338643 105.621721 848.767817z" p-id="6650"></path>
        </svg>
    )
}

const HasBabySvg = (fillColor) => {
    let tmpColor = COLOR.PRIMARY
    if (fillColor) {
        tmpColor = fillColor
    }
    let fillBaby = COLOR.LIME_6
    return (
        <svg t="1713945611022" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8869" width="1.5em" height="1em">
            <path d="M512 69.696c243.84 0 442.304 198.464 442.304 442.304 0 243.84-198.464 442.304-442.304 442.304-243.84 0-442.304-198.464-442.304-442.304C69.696 268.16 268.16 69.696 512 69.696zM512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512-228.736-512-512-512z" fill={tmpColor} p-id="10619"></path>
            <path d="M358.208 334.528a162.944 162.944 0 0 1 163.008 163.008v3.264a70.464 70.464 0 0 0 70.336 70.4c18.368 0 36.8-7.296 50.56-21.76a88.96 88.96 0 0 1 65.728-28.224c51.264 0 93.376 42.048 93.376 93.312 0 27.584-11.84 53.248-33.536 71.68-0.64 0-0.64 0.64-1.28 0.64-7.296 4.608-13.824 9.152-23.04 13.76a393.28 393.28 0 0 1-197.824 53.248 392.32 392.32 0 0 1-310.272-150.528l-1.92-1.92-1.984-1.984-3.968-5.952c-1.92-2.56-3.904-5.888-5.248-7.872a158.72 158.72 0 0 1-25.6-88.064 161.408 161.408 0 0 1 161.664-163.008z m0-69.632A232.704 232.704 0 0 0 125.44 497.536c0 46.72 13.824 90.048 37.504 126.208 2.56 3.904 5.888 8.512 8.512 12.48 2.624 3.968 5.312 7.232 7.936 10.496a464.064 464.064 0 0 0 364.8 176.832c85.376 0 164.928-23.04 233.28-63.104 9.216-5.248 18.368-10.496 26.944-17.088 2.624-1.28 4.608-3.264 7.232-5.248 36.16-29.568 58.496-74.24 58.496-124.864a162.944 162.944 0 0 0-163.008-163.008c-45.376 0-86.72 19.008-116.352 49.92v-2.56a232.704 232.704 0 0 0-232.64-232.704z" fill={fillBaby} p-id="10620"></path>
        </svg>
    )
}

const HasNoBabySvg = (fillColor) => {
    let tmpColor = COLOR.PRIMARY
    if (fillColor) {
        tmpColor = fillColor
    }
    return (
        <svg t="1713945611022" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8869" width="1.5em" height="1em">
            <path d="M512 69.696c243.84 0 442.304 198.464 442.304 442.304 0 243.84-198.464 442.304-442.304 442.304-243.84 0-442.304-198.464-442.304-442.304C69.696 268.16 268.16 69.696 512 69.696zM512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512-228.736-512-512-512z" fill={tmpColor} p-id="10600"></path>
        </svg>
    )
}



// ----------------------------------------------------------------------------------
const TouchIcon = (props) => {
    let { fillColor } = props
    return (
        <div {...props}>
            {TouchSvg(fillColor)}
        </div>
    )
}

const DountIcon = (props) => {
    let { fillColor } = props
    return (
        <div {...props}>
            {DountSvg(fillColor)}
        </div>
    )
}

const SwitchCameraIcon = (props) => {
    let { fillColor } = props
    return (
        <div {...props}>
            {SwitchCameraSvg(fillColor)}
        </div>
    )
}

const BackIcon = (props) => {
    let { fillColor } = props
    return (
        <div {...props}>
            {BackSvg(fillColor)}
        </div>
    )
}

const ShareIcon = (props) => {
    let { fillColor } = props
    return (
        <div {...props}>
            {ShareSvg(fillColor)}
        </div>
    )
}

const HasBabyIcon = (props) => {
    let { fillColor } = props
    return (
        <div {...props}>
            {HasBabySvg(fillColor)}
        </div>
    )
}

const HasNoBabyIcon = (props) => {
    let { fillColor } = props
    return (
        <div {...props}>
            {HasNoBabySvg(fillColor)}
        </div>
    )
}


// ----------------------------------------------------------------------------------
export { TouchIcon, DountIcon, SwitchCameraIcon, BackIcon, ShareIcon, HasBabyIcon, HasNoBabyIcon }
